<div class="progress-container" [hidden]="!isUseTopLoader">
  <div [class]="classProgress()">
    <div [class]="classProgressBar()" >
    </div>
  </div>
</div>
<!--如果逾時等候的彈出跑出來，也先隱藏-->
<div [hidden]="!isUseCenterLoader || !isShowLoader || isWaitingConfirm|| isMainlayoutConfirm" class="loader-wrapper">
  <div class="inner-align-center">
    <!--轉圈圈-->
    <div class="loader-default"></div>
    <div class="loader-fxxk-tip" *ngIf="isDebug"> {{fxxkMsg}}</div>
  </div>
</div>
<!--如果逾時等候的彈出跑出來，也先隱藏-->
<div [hidden]="!isUseCenterLoader || !isShowLoader2 || isWaitingConfirm || isMainlayoutConfirm" class="loader2-wrapper">
</div>